// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Ce79","button-link":"Button_button-link__3ELRc"};